import React, { useCallback } from "react";
import ReactPaginate from "react-paginate";
import ArticleSearchContainer from "../../../containers/ArticleSearchContainer";
import { RESULTS_PER_PAGE } from "../../../../utils/search";

const calcPageRangeDisplayed = (page: number, totalPages: number) => {
  if (totalPages <= 5) {
    return totalPages;
  }
  if (page === 1 || page === totalPages) {
    return 4;
  }
  return 5;
};

function PortalPCPager() {
  const { page, totalPages, switchPageSearch, lastPageUrlRefreshedAt } =
    ArticleSearchContainer.useContainer();

  const handlePageClick = useCallback(
    (selectedItem: { selected: number }) => {
      switchPageSearch(selectedItem.selected + 1);
    },
    [lastPageUrlRefreshedAt]
  );

  if (totalPages <= 1) return null;

  return (
    <nav aria-label="検索結果のページ送り">
      <ReactPaginate
        previousLabel={`前の${RESULTS_PER_PAGE}件`}
        nextLabel={`次の${RESULTS_PER_PAGE}件`}
        previousAriaLabel={`前の${RESULTS_PER_PAGE}件`}
        nextAriaLabel={`次の${RESULTS_PER_PAGE}件`}
        ariaLabelBuilder={(pageIndex: number) => `${pageIndex}ページ目`}
        breakLabel="..."
        pageCount={totalPages}
        marginPagesDisplayed={1}
        pageRangeDisplayed={calcPageRangeDisplayed(page, totalPages)}
        disableInitialCallback
        onPageChange={handlePageClick}
        forcePage={page - 1}
        containerClassName="m_portalPager"
        pageClassName="portalPagerPage"
        pageLinkClassName="portalPagerPageLink"
        activeClassName="isCurrent"
        breakClassName="portalPagerBreak"
        previousClassName="portalPagerNav isPrev"
        nextClassName="portalPagerNav isNext"
        previousLinkClassName="portalPagerNavLink"
        nextLinkClassName="portalPagerNavLink"
        disabledClassName="isDisabled"
      />
    </nav>
  );
}

export default PortalPCPager;
